type EventPass = {
  ticketTypeSlug?: string;
  passId?: string;
  eventDate?: string;
  eventName?: string;
};

export const FASHION_PASS_IMAGE = "/images/event_placeholder.svg";

export function isFashionTicketSlug(slug: string | undefined): boolean {
  return ["fashion-ga", "fashion-vip", "fashion-vip-plus"].includes(slug || "");
}

export function getTicketCatalogImage(slug: string): string {
  return isFashionTicketSlug(slug) ? FASHION_PASS_IMAGE : `/images/passes/${slug}.jpg`;
}

export function getFashionPassEvent(pass: EventPass | undefined) {
  if (!pass || !isFashionTicketSlug(pass.ticketTypeSlug || pass.passId)) return null;
  if (!pass.eventDate || !/^\d{4}-\d{2}-\d{2}$/.test(pass.eventDate)) return null;
  const date = new Date(`${pass.eventDate}T12:00:00Z`);
  if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== pass.eventDate) return null;
  return { eventDate: pass.eventDate, eventName: pass.eventName || "C-Tribe x Fashion Pop-Up Night" };
}

export function formatFashionPassDate(eventDate: string): string {
  return new Intl.DateTimeFormat("en-CA", {
    weekday: "long", month: "long", day: "numeric", year: "numeric", timeZone: "UTC",
  }).format(new Date(`${eventDate}T12:00:00Z`));
}

// A date-only ticket remains upcoming for the entire event day in Edmonton,
// regardless of the attendee's browser timezone.
export function isFashionPassPast(pass: EventPass, now: Date = new Date()): boolean {
  const event = getFashionPassEvent(pass);
  if (!event) return false;
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Edmonton", year: "numeric", month: "2-digit", day: "2-digit",
  }).formatToParts(now);
  const today = ["year", "month", "day"].map((type) => parts.find((part) => part.type === type)!.value).join("-");
  return event.eventDate < today;
}
